import { useChassisVerify } from "hooks/useChassisVerify";
import ChassisNumberField from "./ChassisNumberField";
import { Col, Row } from "reactstrap";
import { useEffect } from "react";
import FormikCreatableField from "./FormikCreatableField";

export default function FullChassisNumber({
  formik,
  optionLoading,
  isLoading,
  id,
  chassisCodesData,
  isEdit,
}) {
  const { isValidChassis, checking, verifyChassis } = useChassisVerify({
    formik,
    chassisCodesData,
    isEdit,
    id,
  })

  useEffect(() => {
    verifyChassis()
  }, [formik.values.vs_chassis_code_id])

  return (
    <Row>
      <Col xs={12} sm={5} className="mb-3">
        <FormikCreatableField
          name="vs_chassis_code_id"
          label="Chassis Code"
          formik={formik}
          data={chassisCodesData}
          placeholder="Select Code"
        />
      </Col>
      <Col xs={12} sm={7} className="mb-3">
        <ChassisNumberField
          formik={formik}
          verifyHandler={{ isValidChassis, checking, verifyChassis }}
          isLoading={isLoading}
          optionLoading={optionLoading}
        />
      </Col>
    </Row>
  )
}
